var React = require('react');

function VerySmallChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"VerySmallChevronRight"},React.createElement("path",{"id":"Vector 416 (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M2.64645 0.646447C2.84171 0.451184 3.15829 0.451184 3.35355 0.646447L6.70711 4L3.35355 7.35355C3.15829 7.54882 2.84171 7.54882 2.64645 7.35355C2.45118 7.15829 2.45118 6.84171 2.64645 6.64645L5.29289 4L2.64645 1.35355C2.45118 1.15829 2.45118 0.841709 2.64645 0.646447Z","fill":"black"})));
}

VerySmallChevronRight.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = VerySmallChevronRight;

VerySmallChevronRight.default = VerySmallChevronRight;
